<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar
      @goOnePage="butsIndex = 0"
      :goodsNumber="goodsNumber"
      :tabbarIndex="4"
      :tabbarInfoShow="false"
    ></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
	<div class="df-maina-ddtit"><span>{{btns[butsIndex].name}}</span></div>
	<div class="df-maina">
	<div class="df-spzx-da">
		<div
			:ref="'btn' + index"
			:class="index == butsIndex ? 'df-spzx-dabox on' : 'df-spzx-dabox'"
			@click="clickedBtns(index)"
			v-for="(item, index) of btns"
			:key="index"
		>
			<div class="df-spzx-dam">{{ item.name }}</div>
			<div class="df-spzx-daico"></div>
		</div>
	</div>
	
	<div class="df-mainar">
    <div class="main1-container">
      <div class="main flexStyle3">
        <!--<div class="left">
          <user-info></user-info>
          <div class="bottom borderShadow">
            <div
              :class="index == butsIndex ? 'hands item item-on' : 'hands item'"
              @click="clickedBtns(index)"
              v-for="(item, index) of btns"
              :key="index"
            >
              <div class="left oneLine">{{ item.name }}</div>
              <div v-if="index == butsIndex" class="right rightright"></div>
            </div>
          </div>
        </div>-->

        <article-list :obj="obj" v-if="butsIndex == 0"></article-list>
        <article-list :obj="obj" v-else-if="butsIndex == 1"></article-list>
        <article-list :obj="obj" v-else-if="butsIndex == 2"></article-list>
        <article-list :obj="obj" v-else-if="butsIndex == 3"></article-list>
        <article-list :obj="obj" v-else-if="butsIndex == 4"></article-list>
        <article-list :obj="obj" v-else-if="butsIndex == 5"></article-list>
      </div>
    </div>
    </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import userInfo from "../../components/userInfo/userInfo";
import articleList from "./components/articleList";
import {
  shoppingCarNumber,
  getArticleTypeListRequest,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      btns: [],
      butsIndex: 0, // 1.2.当前激活按钮
      token: "", // 1.3.token
      goodsNumber: 0, // 1.4.购物车商品数量
      obj: {},
      selectId: null,
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.页面顶部部分
    cFooter: footer, // 2.2.页面底部
    userInfo, // 2.3.左侧右上角客户信息
    articleList,
  },

  methods: {
    // 3.methods
    clickedBtns(index) {
      // 3.1.按钮回调
      if (this.butsIndex != index) {
        this.butsIndex = index;
        this.obj = this.btns[index];
      }
    },
    getArticleTypeList() {
      // 3.7.获取商品列表信息
      let data = {};
      getArticleTypeListRequest(data).then((res) => {
        if (res) {
          this.btns = res.data.map((item, index) => {
            item.name = item.articleTypeName;
            item.id = index;
            item.selectId = item.articleTypeId;
            return item;
          });
          this.obj = this.btns[0];
        }
      });
    },
    getGoodsNumber() {
      // 3.2.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getGoodsNumber(); // 4.1.获取商品数量
      this.getArticleTypeList();
    }
  },
};
</script>

